/**
 * WhatsApp comercial WSJ (site institucional / landing) — Portugal.
 * Não usar para WhatsApp de lojas/clientes no app WSJ Pedidos.
 */
export const WSJ_COMMERCIAL_WHATSAPP_PHONE = '351924963314';

export const WSJ_COMMERCIAL_WHATSAPP_DEFAULT_MESSAGE =
  'Olá! Quero saber mais sobre a WSJ Soluções Digitais.';

/**
 * @param {string} [message] — texto em claro (será codificado)
 * @param {string} [fallbackMessage] — se `message` for vazio
 * @returns {string}
 */
export function getWsjCommercialWhatsappUrl(message, fallbackMessage) {
  const raw = String(message || '').trim();
  const fb = String(fallbackMessage || '').trim() || WSJ_COMMERCIAL_WHATSAPP_DEFAULT_MESSAGE;
  const text = encodeURIComponent(raw || fb);
  return `https://api.whatsapp.com/send?phone=${WSJ_COMMERCIAL_WHATSAPP_PHONE}&text=${text}`;
}
